/**
 * v34.8 — Pubblica pagina "Imposta la tua password" da link invito.
 * Non richiede autenticazione. Legge ?token= dalla querystring, POSTa a
 * /api/auth/set-password-from-token, poi rimanda al login.
 */
import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { Section, Card, Button, Alert, Input, Label } from "../design-system";

const API = process.env.REACT_APP_BACKEND_URL;

export default function SetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);
  const [ok, setOk] = useState(false);

  const submit = async () => {
    setErr(null);
    if (!token) return setErr("Link non valido.");
    if (pw.length < 10) return setErr("La password deve avere almeno 10 caratteri.");
    if (pw !== pw2) return setErr("Le due password non coincidono.");
    setBusy(true);
    try {
      await axios.post(`${API}/api/auth/set-password-from-token`,
        { token, new_password: pw });
      setOk(true);
    } catch (e) {
      const d = e?.response?.data?.detail;
      const msg =
        d === "invalid_token" ? "Link non valido." :
        d === "token_expired" ? "Questo link è scaduto. Richiedi un nuovo invito." :
        d === "token_already_used" ? "Questo link è già stato utilizzato." :
        d === "user_inactive" ? "L'utente non è più attivo. Contatta l'amministratore." :
        d === "new_password_too_short" ? "La password deve avere almeno 10 caratteri." :
        (typeof d === "string" ? d : (e?.message || "Errore. Riprova."));
      setErr(msg);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "#F8FAFC", display: "flex",
                  alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ width: "100%", maxWidth: 480 }}>
        <Card data-testid="set-password-page">
          <Card.Body>
            <h1 style={{ margin: "0 0 6px" }}>
              {ok ? "Password impostata correttamente" : "Imposta la tua password"}
            </h1>
            {!ok && (
              <p className="muted" style={{ fontSize: ".9rem", marginTop: 0 }}>
                Scegli una password di almeno 10 caratteri per completare l'attivazione del tuo accesso al Portale GE SURGELATI.
              </p>
            )}
            {err && <Alert variant="danger" data-testid="set-pw-error">{err}</Alert>}
            {!ok ? (
              <>
                <div style={{ marginTop: 12 }}>
                  <Label>Nuova password</Label>
                  <Input type="password" value={pw} data-testid="set-pw-new"
                         onChange={(e) => setPw(e.target.value)} autoFocus />
                </div>
                <div style={{ marginTop: 12 }}>
                  <Label>Conferma password</Label>
                  <Input type="password" value={pw2} data-testid="set-pw-confirm"
                         onChange={(e) => setPw2(e.target.value)} />
                </div>
                <div style={{ marginTop: 20 }}>
                  <Button variant="primary" full onClick={submit} loading={busy} disabled={busy}
                          data-testid="set-pw-submit">
                    {busy ? "Salvataggio…" : "Imposta password"}
                  </Button>
                </div>
              </>
            ) : (
              <div data-testid="set-pw-success">
                <p style={{ margin: "8px 0 16px" }}>
                  Ora puoi accedere al Portale GE SURGELATI con la tua nuova password.
                </p>
                <Button variant="primary" full onClick={() => nav("/login")}
                        data-testid="set-pw-go-login">Vai al login</Button>
              </div>
            )}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
